export enum FetchType {
    Post = 1,
    Get = 2
}